export default __webpack_public_path__ + "static/media/favicon.be70f0b5.ico";